exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._28WP_Dzg4TEkmBm7T7FLy9{\n    fill-opacity: 0.85 ;\n}\n\n._28WP_Dzg4TEkmBm7T7FLy9:hover{\n    fill-opacity: 1 ;\n    -webkit-box-shadow: 0 0 11px rgba(33, 33, 33, 0.493);\n            box-shadow: 0 0 11px rgba(33, 33, 33, 0.493); \n    width: 1000px;\n}\n\n._2ZZyF23z2QksxetPR0bqYU {\n    font-size: 15px;\n    /* font-weight: 600; */\n    color: #000;\n    fill: #000;\n    /* font-family: 'Soleil', 'Helvetica Neue', helvetica, arial, sans-serif; */\n    cursor: pointer;\n}\n\n._1qQrg_8OU6BcOIqUmIJZ6g {\n    font-size: 15px;\n    font-weight: 600;\n    color: #000;\n    fill: #000;\n    font-family: 'Soleil', 'Helvetica Neue', helvetica, arial, sans-serif;\n    cursor: pointer;\n}", ""]);

// exports
exports.locals = {
	"beat": "_28WP_Dzg4TEkmBm7T7FLy9",
	"LeadTitle": "_2ZZyF23z2QksxetPR0bqYU",
	"LeadTitleDelete": "_1qQrg_8OU6BcOIqUmIJZ6g"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/pages/Annotation/components/Interval/interval.css
// module id = 9760
// module chunks = 23